import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';

interface IState {
  commission: number;
}

interface IProps {
  price: number;
  commissionType?: string;
  commissionValue: number | string;
  format?: string;
  hasVariations?: boolean;
}

class CalculateCommissionAffiliate extends Component<IProps, IState> {
  static getDerivedStateFromProps(nextProps: IProps): IState {
    let commission: any = null;

    if (nextProps.commissionType) {
      commission = nextProps.commissionValue;
    }

    return { commission };
  }
  defaultProps = {
    hasVariations: false,
  };
  constructor(props: IProps) {
    super(props);

    this.state = {
      commission: 0,
    };
  }
  render() {
    const { commissionType } = this.props;

    if (commissionType === 'V') return <FormattedNumber format='BRL' value={this.state.commission} />;
    if (commissionType === 'P') return <>{this.state.commission}%</>;

    return <FormattedNumber value={this.state.commission ? this.state.commission : 0} format={this.props.format ? this.props.format : 'BRL'} />;
  }
}

export default CalculateCommissionAffiliate;
